<div class="modal-container">
  <button class="close-btn" (click)="dialogRef.close()">✕</button>
  <h2 mat-dialog-title style="padding-bottom: 8px">
    {{ "cookies.MANAGECONSENT" | translate }}
  </h2>

  <mat-dialog-content>
    <div class="description">
      {{ "cookies.FULLDESCRIPTION" | translate }}
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="actions">
    <button class="btn accept" (click)="dialogRef.close('accept')">
      {{ "cookies.ACCEPT" | translate }}
    </button>
    <button class="btn deny" (click)="dialogRef.close('deny')">
      {{ "cookies.DENY" | translate }}
    </button>
  </mat-dialog-actions>
</div>
